import { COMPONENT_STATES, COMPONENT_TYPE as TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { generateElementId, generateNodeId } from 'utils/generate-id';
import View from 'client/components/common/BuildingBlocks/Embed/Embed';

export const EMBED = () => {
	const _id = generateElementId();

	return {
		view: View,
		model: {
			_id,
			type: TYPE.EMBED,
			uiConfig: {
				layer: undefined,
				editorProps: {
					name: EMBED.displayName,
					selectable: true,
					draggable: true,
					expandable: false,
					expanded: false,
				},

				componentProps: {
					styles: {
						[COMPONENT_STATES.DEFAULT]: {
							[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {},
						},
					},
					other: {},
				},
				nodeProps: {
					id: generateNodeId(_id, EMBED.displayName),
				},
			},
			children: [],
		},
	};
};

EMBED.displayName = 'Embed';
